import {
  countByStatus,
  latestPerBill,
  type WhatsappStatus as Status,
  WHATSAPP_STATUS_COLORS,
  WHATSAPP_STATUS_LABELS,
} from '@horof/shared';
import { Tag } from 'antd';
import { useMemo } from 'react';
import { useQuery } from 'urql';
import { Step } from './Step';
import { MonthWhatsappDocument } from './whatsapp-data';

const refetchMessages = { additionalTypenames: ['WhatsappMessage'] };

/**
 * How the month's invoices reached the members (to follow). Sending and
 * re-sending are done on the desk (docs/changes/43–44).
 */
export function WhatsappStatus({
  n,
  start,
  end,
}: {
  n: number;
  start: string;
  end: string;
}) {
  const [{ data }] = useQuery({
    query: MonthWhatsappDocument,
    variables: { start, end },
    context: refetchMessages,
  });
  const messages = useMemo(
    () => latestPerBill(data?.whatsappMessages?.nodes ?? []),
    [data],
  );
  const counts = countByStatus(messages);
  const failed = messages.filter((m) => m.status === 'FAILED');

  return (
    <Step
      n={n}
      title="الفواتير عبر واتساب"
      state={!messages.length ? 'todo' : counts.FAILED ? 'warn' : 'done'}
      summary={
        messages.length ? (
          <div className="status-tags">
            {(Object.keys(counts) as Status[])
              .filter((s) => counts[s])
              .map((s) => (
                <Tag
                  key={s}
                  color={WHATSAPP_STATUS_COLORS[s]}
                  className="big-tag"
                >
                  {WHATSAPP_STATUS_LABELS[s]}: {counts[s]}
                </Tag>
              ))}
          </div>
        ) : (
          'لم تُرسل أي فاتورة لهذا الشهر بعد.'
        )
      }
    >
      {failed.length > 0 && (
        <ul className="plain-list">
          {failed.map((m) => (
            <li key={m.id}>
              <strong>{m.member?.fullName}</strong>{' '}
              <span className="ltr-num field-hint">{m.toPhone}</span>
            </li>
          ))}
        </ul>
      )}
      <div className="field-hint">
        تُرسل الفواتير وتُعاد من الحاسوب («مكتب الجمعية»، إغلاق الشهر).
      </div>
    </Step>
  );
}
